function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default (function (theme, _ref) {
  var getColor = _ref.getColor;
  return {
    getCSS: function getCSS(_ref2) {
      var color = _ref2.color,
          __internal__focus = _ref2.__internal__focus;
      var focusStyle = {
        outline: 0,
        borderRadius: theme.radii[0],
        boxShadow: theme.shadows.focus
      };
      return _objectSpread({
        boxSizing: "border-box",
        width: "100%",
        minHeight: "60px",
        resize: "vertical",
        border: 0,
        margin: 0,
        fontSize: theme.fontSizes[1],
        fontWeight: theme.fontWeights.light,
        lineHeight: theme.lineHeights[2],
        fontFamily: theme.fonts.body,
        color: theme.colors.black,
        backgroundColor: getColor(color),
        padding: "".concat(theme.space[2], " ").concat(theme.space[4]),
        ":focus": focusStyle
      }, __internal__focus && focusStyle);
    }
  };
});